import * as Yup from 'yup'

import {
  DOC_FLOW_FORM_FIELD_TITLE,
  DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
} from '../../../DocFlow.constants'

export function getDocFlowProfileHeaderEditTitleInitialValue(title) {
  return {
    [DOC_FLOW_FORM_FIELD_TITLE]: title,
  }
}

export function getDocFlowProfileHeaderEditTitlePayload(values) {
  return {
    [DOC_FLOW_FORM_FIELD_TITLE]: values[DOC_FLOW_FORM_FIELD_TITLE],
  }
}

export function getDocFlowProfileHeadertEditTitleValidationSchema(t) {
  return Yup.object({
    [DOC_FLOW_FORM_FIELD_TITLE]: Yup.string()
      .required(true)
      .max(
        DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: DOC_FLOW_FORM_TITLE_FIELD_MAX_LENGTH,
        })
      ),
  })
}
